import React, { useState, useEffect } from "react";
import { Box, Button, Typography, Modal } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setUser } from "../redux/userSlice";
import OtpComponent from "./Otp";

const Register = () => {
  const [data, setData] = useState({});
  const [otp, setOtp] = useState("");
  const [error, setError] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validate = (name, value) => {
    const errors = { ...formErrors };

    if (name === "username") {
      if (!value) errors.username = "Mobile number is required.";
      else if (!/^\d{10}$/.test(value)) errors.username = "Invalid mobile number.";
      else delete errors.username;
    }

    if (name === "email") {
      if (!value) errors.email = "Email is required.";
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) errors.email = "Invalid email address.";
      else delete errors.email;
    }

    if (name === "password") {
      if (!value) errors.password = "Password is required.";
      else if (value.length < 6) errors.password = "Password must be at least 6 characters.";
      else delete errors.password;
    }

    setFormErrors(errors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
    validate(name, value);
  };

  const handleRegister = async () => {
    if (Object.keys(formErrors).length > 0 || !data.username || !data.email || !data.password) {
      setError("Please enter valid data before proceeding.");
      return;
    }

    try {
      const verify = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/auth/verify-signup-otp?email=${data.email}&otp=${otp}`);

      if (verify) {
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth/signup`, {
          username: data.username,
          password: data.password,
          email: data.email,
        });

        const res = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/auth/signin`,
          { username: data.username, password: data.password }
        );

        setIsOtpModalOpen(false);
        dispatch(setUser(res.data));
        navigate("/profile");
      }
    } catch (error) {
      console.log(error)
      setError(error.response.data.Exception || error.response.data || "Registration failed");
    }
  };

  const handleSendOtp = async () => {
    if (Object.keys(formErrors).length > 0 || !data.username || !data.email || !data.password) {
      setError("Please fill the required data correctly");
      return;
    }

    try {
      await axios.get(`${process.env.REACT_APP_BACKEND_URL}/auth/generate-signup-otp?email=${data.email}`);
      setIsOtpModalOpen(true);
    } catch (error) {
      setError("Please enter a valid OTP");
    }
  };

  return (
    <Box className="parent-div">
      <div className="eclipse1"></div>
      <div className="eclipse2"></div>
      <Box
        sx={{
          padding: "20px 20px",
          zIndex: 100,
          position: "relative",
        }}
      >
        <Typography className="heading">Go ahead and set up your account</Typography>
        <Typography className="sub-heading">
          Sign up to enjoy the best managing experience
        </Typography>
      </Box>
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
        }}
        className="main-container"
      >
        <input
          type="text"
          name="username"
          id="username"
          placeholder="Mobile No"
          onChange={handleChange}
        />
        {formErrors.username && <Typography sx={{ color: "red", fontSize: '12px', lineHeight: '0.1rem', marginLeft: '25px' }}>{formErrors.username}</Typography>}

        <input
          type="email"
          name="email"
          id="email"
          placeholder="Email"
          onChange={handleChange}
        />
        {formErrors.email && <Typography sx={{ color: "red", fontSize: '12px', lineHeight: '0.1rem', marginLeft: '25px' }}>{formErrors.email}</Typography>}

        <input
          type="password"
          name="password"
          id="password"
          placeholder="Password"
          onChange={handleChange}
        />
        {formErrors.password && <Typography sx={{ color: "red", fontSize: '12px', lineHeight: '0.1rem', marginLeft: '25px' }}>{formErrors.password}</Typography>}

        {/* {error && <Typography sx={{ color: "red", fontSize: '12px', marginLeft: '25px' }}>{error}</Typography>} */}
        {/* <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography>
            <input type="checkbox"></input> Remember Me
          </Typography>
        </Box> */}
        <Typography textAlign={"center"} mt={3}>
          Already have an account? <a href="/">Sign In</a>
        </Typography>
        <Button variant="contained" onClick={handleSendOtp}>
          Register
        </Button>
      </form>

      {/* OTP Modal */}
      <Modal open={isOtpModalOpen} onClose={() => setIsOtpModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 250,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
          }}
        >
          <Typography variant="h6" textAlign="center" mb={2}>
            Enter OTP
          </Typography>
          <OtpComponent otp={otp} onOtpChange={setOtp} />
          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 3 }}
            onClick={handleRegister}
          >
            Verify OTP
          </Button>
        {error && <Typography sx={{ color: "red", fontSize: '12px', textAlign: 'center' }}>{error}</Typography>}
        </Box>
      </Modal>
    </Box>
  );
};

export default Register;